import { ErrorBoundary, IconButton, Tooltip } from "@prismicio/editor-ui"
import { Suspense } from "react"

import { useHasPublisherPermission } from "../DocumentList.utils"
import { useBulkActionsButton } from "./useBulkActionsButton"
import { transformDocumentToBulkTaskItem } from "./utils"

interface ArchiveDocumentsButtonProps {
  /**
   * Provided when archiving documents in a release
   */
  releaseId?: string
}

export function ArchiveDocumentsButton(props: ArchiveDocumentsButtonProps) {
  const { releaseId } = props

  return (
    <ErrorBoundary renderError={Fallback}>
      <Suspense fallback={<Fallback />}>
        <ArchiveButton releaseId={releaseId} />
      </Suspense>
    </ErrorBoundary>
  )
}

function ArchiveButton(props: ArchiveDocumentsButtonProps) {
  const { releaseId } = props
  const { action, disabled, tooltip, getSelectedDocuments } =
    useBulkActionsButton({
      hasPermission: useHasPublisherPermission(),
      releaseId,
    })

  function onClick() {
    const items = getSelectedDocuments().map((document) =>
      transformDocumentToBulkTaskItem(document, releaseId),
    )

    action("archive", { items })
  }

  return (
    <Tooltip content={tooltip || "Archive"}>
      <IconButton
        icon="inventory"
        onClick={onClick}
        disabled={disabled}
        color="grey"
      />
    </Tooltip>
  )
}

function Fallback() {
  return <IconButton icon="inventory" disabled color="grey" />
}
